
import React, { FC } from 'react';
import { isMobile } from 'react-device-detect';
import { observer } from 'mobx-react-lite';
import { HeaderMobile } from './HeaderMobile';
import { HeaderDesktop } from './HeaderDesktop';
import '../../styles/components/header.scss';

export const Header: FC = observer(() => (
  <>
    <div id="modalContainer" />
    {isMobile
      ? <HeaderMobile />
      : <HeaderDesktop />}
  </>
));
